export default __webpack_public_path__ + "static/favicon-2e307d2a7a7b7ab1b7f742528296e1be.ico";